import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { SocialNet } from '../../domain/interfaces/social-net';
import { createFetchSocialNetsReducer, createSaveSocialNetsReducer } from './reducers';

export interface SocialNetsSliceState {
  isLoading: boolean;
  isLoaded: boolean;
  isProcessing: boolean;
  process: 'create' | 'update' | 'delete' | null;

  data: SocialNet[];
  tournamentId: number | null;
}

const initialState: SocialNetsSliceState = {
  isLoaded: false,
  isLoading: false,
  isProcessing: false,
  process: null,

  data: [],
  tournamentId: null,
};

export const socialNetsSlice = createSlice({
  name: 'socialNets',
  initialState,
  reducers: {
    setTournamentId: (state, action: PayloadAction<number>) => {
      state.tournamentId = action.payload;
    },
  },
  extraReducers: (builder) => {
    createFetchSocialNetsReducer(builder);
    createSaveSocialNetsReducer(builder);
  },
});

export const { setTournamentId } = socialNetsSlice.actions;

export default socialNetsSlice.reducer;
